import { z } from 'zod';
import { clipKindSchema } from '../clipKind';

export const queueUploadResponseSchema = z.object({
  queued: z.boolean(),
  clipId: z.number(),
  jobs: z.array(
    z.object({
      id: z.number(),
      kind: clipKindSchema,
    }),
  ),
});

export type IQueueUploadResponse = z.infer<typeof queueUploadResponseSchema>;
